export enum SOURCES_TYPES {
	DAILY = 'DAILY',
	DAILY_V2 = 'DAILY_V2',
	SCENE = 'SCENE',
	WORD = 'WORD',
	FLASH_CARD_V2 = 'FLASH_CARD_V2',
	WORD_TRAINER = 'WORD_TRAINER',
	IMAGE_MODE = 'IMAGE_MODE',
	CALL_MODE = 'CALL_MODE',
	NEWS = 'NEWS',
}
